<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_4"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="para"><span class="smallcaps">COLD CHOICES</span></p>
<p class="linespace"> </p>
<p class="para">Copyright © 2009 by Larry Bond and Chris Carlson</p>
<p class="linespace"> </p>
<p class="para">All rights reserved.</p>
<p class="linespace"> </p>
<p class="para">A Forge Book</p>
<p class="para">Published by Tom Doherty Associates, LLC</p>
<p class="para">175 Fifth Avenue</p>
<p class="para">New York, NY 10010</p>
<p class="linespace"> </p>
<p class="para"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="linespace"> </p>
<p class="para">Forge<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="linespace"> </p>
<p class="para">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace"> </p>
<p class="para">Bond, Larry.</p>
<p class="indent-para">Cold choices / Larry Bond.—1st ed.</p>
<p class="indent-para">       p. cm.</p>
<p class="indent-para">“A Tom Doherty Associates book.”</p>
<p class="indent-para">ISBN-13: 978-0-7653-1875-6</p>
<p class="indent-para">ISBN-10: 0-7653-1875-X</p>
<p class="para">  1. Submarines (Ships)—United States—Fiction. 2. Submarines (Ships)—Russia (Federation)—Fiction. 3. Submarine captains—Fiction. 4. Naval reconnaissance—Fiction. 5. Submarine combat—Fiction. 6. Submarine disasters—Fiction. 7. Search and rescue operations—Fiction. I. Title.</p>
<p class="indent-para">PS3552.O59725C66 2009</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="indent-para">813'.54—dc22</p></td>
<td valign="top"><p class="para">2008050414</p></td>
</tr>
</tbody></table>
<p class="para"> </p>
<p class="para">First Edition: May 2009</p>
<p class="linespace"> </p>
<p class="para">Printed in the United States of America</p>
<p class="linespace"> </p>
<p class="para">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?f7801120